import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconSuccessFilled } from "blocks-nextjs/blocks-react/components/Icons/SuccessFilled/SuccessFilled";
import { CatToast } from "blocks-nextjs/blocks-react/components/Toast/Toast";
import React, { useEffect } from "react";
const CopyLinkToast = ({ onClose, show }) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onClose();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);
    if (!show)
        return null;
    return (_jsx("div", { className: "fixed top-4 left-1/2 transform -translate-x-1/2 z-[99999] pointer-events-none w-[628px] h-[72px]", children: _jsx("div", { className: "pointer-events-auto w-full h-full", children: _jsxs(CatToast, { delay: 4, onBlToastClose: onClose, variant: "success", children: [_jsx(CatIconSuccessFilled, { slot: "before" }), _jsxs("div", { children: [_jsx(CatHeading, { variant: "label-sm", children: "Link Copied Successfully" }), _jsx("p", { className: "text-sm text-gray-600 mt-1", children: "Please share this link in a secure way as anybody with this link can access the data." })] })] }) }) }));
};
export default CopyLinkToast;
